import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error: any) => {
                // Don't retry on client errors (4xx) including rate limits (429)
                if (error?.response?.status >= 400 && error?.response?.status < 500) {
                    return false
                }
                // Retry server errors (5xx) once
                return failureCount < 1
            },
            retryDelay: 1000, // Wait 1 second before retry
            staleTime: 2 * 60 * 1000, // Data is fresh for 2 minutes
            cacheTime: 10 * 60 * 1000, // Keep cached data for 10 minutes
            refetchOnWindowFocus: true, // Refetch when user returns to tab
            refetchOnReconnect: true, // Refetch when network reconnects
        },
    },
})
